import { BaseModel } from '../../_base/crud';

export class LinkGroup extends BaseModel {
  id: number;
  name: string;
  links: any[];
  teamIds: any[];
  teams: any[];
}
